import axios from "axios";
import { getToken, userId } from "./LocalStorage";

export const executePost = async (endPoint, data) => {
  const Auth_Token = getToken();
  const business_id = userId();
  return await axios.post(process.env.REACT_APP_BACKEND_URL + endPoint, data, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Token: Auth_Token,
      Business:business_id
    },
  });
};

export const ExportExecutePost = async (endPoint, data) => {
  const Auth_Token = getToken();
  const business_id = userId();
  return await axios.post(process.env.REACT_APP_BACKEND_URL + endPoint, data, {
    responseType: "blob",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Token: Auth_Token,
      Business:business_id,
    },
  });
};

// export const executeGET = async (endPoint, data) => {
//   const Auth_Token = getToken();
//   const business_id = userId();
//   return await axios.get(process.env.REACT_APP_BACKEND_URL + endPoint, data, {
//     headers: {
//       Accept: "application/json",
//       "Content-Type": "application/json",
//       Token: Auth_Token,
//       Business:business_id,
//     },
//   });
// };


export const executeGET = async (endPoint, params = {}) => {
  const Auth_Token = getToken();
  const business_id = userId();

  return await axios.get(
    process.env.REACT_APP_BACKEND_URL + endPoint,
    {
      params: params, // 👈 GET data yahan jayega
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Token: Auth_Token,
        Business: business_id,
      },
    }
  );
};
